import { BASE_URL } from "../../../../Constant";

export const API_PACKAGE_SUB_CATEGORY_SAVE: string = BASE_URL + '/business/packageSubCategory'; 
export const API_PACKAGE_SUB_CATEGORY_UPDATE: string = BASE_URL + '/business/packageSubCategory'; 
export const API_PACKAGE_SUB_CATEGORY_DELETE: string = BASE_URL + '/business/packageSubCategory'; 
export const API_PACKAGE_SUB_CATEGORY_CHANGE_STATUS: string = BASE_URL + '/business/packageSubCategory/changeStatus'; 